import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import data from '../data.json';

// Use PUBLIC_URL for correct image paths
const lightHeaderImage = `${process.env.PUBLIC_URL}/light-theme-bible.jpg`;
const darkHeaderImage = `${process.env.PUBLIC_URL}/dark-theme.jpg`;

const Header = ({ mode }) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${mode === 'light' ? lightHeaderImage : darkHeaderImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <Container>
        <Box sx={{ textAlign: 'center', mt: 4, pb: 4 }}>
          <Typography variant="h1">{data.name}</Typography>
          <Typography variant="body1">{data.bio}</Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
